import styled from 'styled-components';

import { colors } from 'theme/theme';

export const CmsSocialSidebarContainer = styled.div<{
  $hasTableOfContents: boolean;
}>`
  position: relative;
  ${(props) => `top: ${props.$hasTableOfContents ? 72 : 400}px;`};
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 28px;
`;

export const CmsSocialSidebarRecentJobsContainer = styled.div`
  padding-bottom: 8px;
`;

export const CmsSocialSidebarTooltipContainer = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
`;

const cmsSocialSidebarButtonContainerBase = `
  background-color: ${colors.calloutGrey};
  color: ${colors.lightContentGrey};
  border-radius: 32px;
  &:hover {
    color: ${colors.hoverBlue};
    background-color: ${colors.softBlue};
  }
`;

export const CmsSocialSidebarShareButtonContainer = styled.button`
  ${cmsSocialSidebarButtonContainerBase}
  padding: 8px;
`;

export const CmsSocialSidebarNewsletterButtonContainer = styled.button`
  ${cmsSocialSidebarButtonContainerBase}
  padding: 5px;
`;
